import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import {
  Divider,
  Icon,
  Segment,
  Grid,
  Image,
  Table,
  Label,
  Popup,
  Statistic,
  Loader,
} from 'semantic-ui-react';

import FollowersBarChart from 'dyzio-shared-components/lib/components/followers-bar-chart';

import {
  commaFormatted,
  ierFormat2DP,
  countFormat,
} from '../../utils/helpers/formatting';

const iconStyle = {
  'vertical-align': 'middle',
  display: 'inline',
  height: 35,
};

const loadingStyle = {
  minHeight: 90,
  marginTop: 30,
};

const textCenterStyle = {
  textAlign: 'center',
  width: '100%',
};

class TiktokProfileDataLarge extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      profile: {},
    };
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_GET_TWITTER_URL,
      timeout: 5000,
    });

    axiosRetry(this.restClient, {
      delay: 100,
      retries: 3,
    });
  }

  async componentWillMount() {
    console.log('data mount');
  }

  render() {
    const {
      influencer,
      countHistory,
    } = this.props;
    const {
      profile,
      loading,
    } = this.state;
    const {
      tiktokProfileData,
      tiktokThumbnail,
    } = influencer;

    const {
      engagementData,
      verified,
      username: handle,
    } = tiktokProfileData || {};

    const {
      postsPerWeek,
      likes,
      comments,
      shares,
      engagementRate,
    } = engagementData || {};

    console.log('tiktok profile', profile);

    let tiktokData = _.filter(countHistory, item => _.has(item, 'tiktokCount'));
    if (_.isEmpty(tiktokData)) {
      tiktokData = [{
        tiktokCount: _.get(influencer, 'tiktokCount'),
        createdDate: moment().format('MMM D'),
      }];
    }
    console.log('tiktokData', tiktokData);
    const graphProps = {
      label: 'followers',
      labels: _.map(tiktokData, item => moment(item.createdDate).format('MMM D')),
      values: _.map(tiktokData, 'tiktokCount'),
      rgbColorCode: '#000',
    };
    const lastTiktokScan = _.last(tiktokData);
    return (
      <Segment color="black">
        {
          loading &&
          <Loader
            active
            inline="centered"
            content="Loading Tiktok data"
            style={loadingStyle}
          />
        }
        {!loading && <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <h3>
                <Image src="/icons/tiktok.svg" alt="Tiktok" style={iconStyle} />
                Tiktok
              </h3>
              <Divider />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row divided>
            <Grid.Column width={4}>
              <Image
                src={tiktokThumbnail}
                shape="circular"
                centered
                size="small"
              />
              <Table basic="very" fluid textAlign="center">
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      { handle }
                      { verified && <Icon name="check circle" color="blue" /> }
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>{commaFormatted(lastTiktokScan.tiktokCount)} followers</Table.Cell>
                  </Table.Row>
                  {
                    !verified &&
                    <Table.Row>
                      <Table.Cell>
                        <Popup
                          trigger={<Label basic color="grey" content="not verified" />}
                          content={`${handle} is not verified by Tiktok (blue tick)`}
                        />
                      </Table.Cell>
                    </Table.Row>
                  }
                </Table.Body>
              </Table>
            </Grid.Column>
            <Grid.Column width={7}>
              <FollowersBarChart {...graphProps} percentageRange={0.5} />
            </Grid.Column>
            <Grid.Column width={5}>

              { loading && <Loader active content="Loading..." /> }
              { engagementRate && !loading &&
                <div>
                  <Statistic style={textCenterStyle}>
                    <Statistic.Value>{ierFormat2DP(engagementRate)}%</Statistic.Value>
                    <Statistic.Label>engagement rate</Statistic.Label>
                  </Statistic>
                  <Table basic="very" fluid compact>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>posts per week</Table.Cell>
                        <Table.Cell>{countFormat(postsPerWeek)}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>avg. likes per post</Table.Cell>
                        <Table.Cell>{countFormat(likes)}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>avg. comments per post</Table.Cell>
                        <Table.Cell>{countFormat(comments)}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>avg. shares per post</Table.Cell>
                        <Table.Cell>{countFormat(shares)}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </div>
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>}
      </Segment>
    );
  }
}

TiktokProfileDataLarge.propTypes = {
  influencer: PropTypes.object.isRequired,
  countHistory: PropTypes.array,
};

TiktokProfileDataLarge.defaultProps = {
  countHistory: [],
};

export default TiktokProfileDataLarge;



/** WEBPACK FOOTER **
 ** ./src/components/tiktok-profile-data-large/index.js
 **/